'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiRadarOutline = function TiRadarOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 7.5c-7.8 0-14.2 6.4-14.2 14.2s6.4 14.1 14.2 14.1c7.8 0 14.2-6.3 14.2-14.1s-6.4-14.2-14.2-14.2z m0 25c-6 0-10.8-4.9-10.8-10.8s4.8-10.9 10.8-10.9c6 0 10.8 4.9 10.8 10.9s-4.8 10.8-10.8 10.8z m5.6-12.4c0.1-0.1 0.1-0.1 0.2-0.1h1.5c-0.6-2.8-2.8-5-5.6-5.6v1.4c0 1-0.8 1.7-1.7 1.7-0.8 0-1.5-0.6-1.6-1.4 0-0.1-0.1-0.2-0.1-0.3v-1.4c-2.8 0.6-5 2.8-5.6 5.6h1.5c0.1 0 0.1 0 0.2 0 0.8 0.2 1.4 0.8 1.4 1.7s-0.6 1.5-1.4 1.6c-0.1 0-0.1 0-0.2 0h-1.5c0.6 2.8 2.8 5 5.6 5.7v-1.5c0-0.1 0.1-0.2 0.1-0.3 0.1-0.8 0.8-1.4 1.6-1.4s1.5 0.7 1.6 1.4c0 0.1 0.1 0.2 0.1 0.3v1.5c2.8-0.7 5-2.9 5.6-5.7h-1.5c-0.1 0-0.1 0-0.2 0-0.8-0.1-1.4-0.8-1.4-1.6s0.6-1.5 1.4-1.7z m-0.8 4.7c-0.4 0.7-1 1.3-1.6 1.7-0.5-1.4-1.7-2.3-3.2-2.3s-2.7 1-3.2 2.3c-0.6-0.4-1.2-1-1.6-1.7 1.3-0.4 2.3-1.6 2.3-3.1 0-1.5-1-2.8-2.3-3.2 0.4-0.7 1-1.2 1.6-1.7 0.5 1.4 1.7 2.4 3.2 2.4 1.5 0 2.7-1 3.2-2.4 0.6 0.5 1.2 1 1.6 1.7-1.3 0.4-2.3 1.7-2.3 3.2 0 1.5 1 2.7 2.3 3.1z' })
        )
    );
};

exports.default = TiRadarOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/radar-outline.js
// module id = 3934
// module chunks = 0